<template>
  <section class="faq-hero" ref="root">
    <div class="faq-hero__inner" :class="{ 'faq-hero__inner_visible': visible }">
      <h1 class="faq-hero__title">Частые вопросы</h1>
      <p class="faq-hero__subtitle">
        Ответы на основные вопросы о материалах, сроках, доставке и заказе.
      </p>
      <div class="faq-hero__cta-wrap">
        <button type="button" class="faq-hero__cta" @click="openQuestionForm">
          Напишите нам
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'FaqHero',
  setup() {
    const store = useStore()
    const root = ref(null)
    const visible = ref(false)

    function openQuestionForm() {
      store.commit('setQuestionModalOpen', true)
    }

    onMounted(() => {
      requestAnimationFrame(() => { visible.value = true })
    })

    return { root, visible, openQuestionForm }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";

$dur: 0.7s;
$ease: cubic-bezier(0.22, 1, 0.36, 1);

.faq-hero {
  padding: 100px $gap 80px;
  background: $color-bg-alt;
  color: $color-primary-inverse;

  @media (max-width: $breakpoint-mobile) {
    padding: 72px $gap 56px;
  }

  &__inner {
    max-width: $container-max;
    margin: 0 auto;
    text-align: center;
  }

  &__title {
    font-size: clamp(32px, 5vw, 44px);
    font-weight: 800;
    letter-spacing: -0.02em;
    margin: 0 0 16px;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $dur $ease, transform $dur $ease;

    .faq-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__subtitle {
    font-size: clamp(15px, 1.8vw, 18px);
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
    max-width: 480px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
    opacity: 0;
    transform: translateY(16px);
    transition: opacity $dur $ease, transform $dur $ease;
    transition-delay: 0.08s;

    .faq-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__cta-wrap {
    margin-top: 36px;
    opacity: 0;
    transform: translateY(16px);
    transition: opacity $dur $ease, transform $dur $ease;
    transition-delay: 0.15s;

    .faq-hero__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__cta {
    padding: 14px 32px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: $color-primary-inverse;
    background: $color-accent-teal;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-family: inherit;
    box-shadow: 0 8px 24px rgba(97, 130, 111, 0.45);
    transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;

    &:hover {
      opacity: 0.95;
      box-shadow: 0 12px 32px rgba(97, 130, 111, 0.55);
    }
    &:active {
      transform: scale(0.98);
    }
  }
}
</style>
